import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { NoteConceptDetailResponse } from 'src/app/models/invoicing/note-concept-detail-response.mode';
import { NoteConceptModel } from 'src/app/models/invoicing/note-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NoteConceptService {

  constructor(private _httpClient: HttpClient) { }

  getNoteConceptById(noteConceptId: number): Observable<NoteConceptModel> {
    return this._httpClient.get<NoteConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetNoteConceptById}/${noteConceptId}`);
  }

  getNoteConceptDetailsByNoteId(noteId: number): Observable<Array<NoteConceptDetailResponse>> {
    return this._httpClient.get<Array<NoteConceptDetailResponse>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetNoteConceptDetailsByNoteIdAsync}/${noteId}`)
  }

  getNoteConceptByKeys(noteId: number, conceptInvoicingId: number, storeId: number): Observable<NoteConceptDetailResponse> {
    let params = new HttpParams()
    params = params.set('noteId', noteId)
    params = params.set('conceptInvoicingId', conceptInvoicingId)
    params = params.set('storeId', storeId)
    return this._httpClient.get<NoteConceptDetailResponse>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetNoteConceptByKeysAsync}`, { params: params });
  }

  createNoteConcept(noteConceptContract: NoteConceptModel): Observable<NoteConceptModel> {
    return this._httpClient.post<NoteConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.CreateNoteConcept}`,
      noteConceptContract);
  }

  updateNoteConcept(noteContract: NoteConceptModel): Observable<NoteConceptModel> {
    return this._httpClient.put<NoteConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.UpdateNoteConcept}`,
      noteContract);
  }

  deleteSomeNoteConcepts(noteConceptsIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.DeleteSomeNoteConcepts}`,
      noteConceptsIds);
  }

  getColumnsForConceptConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetColumnsForConceptConsultation}`);
  }

  getAllNoteConceptsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], isDocumentSupport: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('isDocumentSupport', isDocumentSupport);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetAllNoteConceptsWithPagination}`,
      filters, { params: params }
    );
  }

  exportConceptConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, isDocumentSupport: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString())
      .set('isDocumentSupport', isDocumentSupport);

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.ExportConceptConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  GetColumnsForConceptDetailsNoteAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetColumnsForConceptDetailsNoteAsync}`);
  }

  getNotesConceptDetailsByNoteIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, noteId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('noteId', noteId);

    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetNotesConceptDetailsByNoteIdWithPagination}`,
      { params }
    );
  }

  getReteFuenteByNoteAndConcept(noteId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetReteFuenteByNoteAndConcept}/${noteId}/${conceptInvoicingId}`);
  }

  getReteIcaByNoteAndConcept(noteId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetReteIcaByNoteAndConcept}/${noteId}/${conceptInvoicingId}`);
  }

  getIvaRateByNoteAndConcept(noteId: number, conceptInvoicingId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteConcept.GetIvaRateByNoteAndConcept}/${noteId}/${conceptInvoicingId}`);
  }
}
